<template>
  <div class="edu-about-area ptb-100">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-7 col-md-12">
          <div class="edu-about-image">
            <img src="../../assets/img/all-img/about3.png" alt="image" />
          </div>
        </div>
        <div class="col-lg-5 col-md-12">
          <div class="edu-about-content">
            <p class="sub-title">Cvision</p>
            <h2>
              En İyi Online <span class="shape02">Eğitimi</span> Biz Sunuyoruz.
            </h2>
            <p>
              Sunduğumuz online eğitimlerle her zaman en kaliteli içeriklere ulaşabilirsiniz
            </p>
            <div class="progress-content">
              <div class="progress-section">
                <div class="progress-title">
                  <h4>İşletme Çalışmaları</h4>
                  <span class="title">86%</span>
                </div>
                <div class="progress">
                  <div class="progress-bar psc01" role="progressbar" aria-valuenow="91" aria-valuemin="0"
                    aria-valuemax="100" style="max-width: 91%"></div>
                </div>
              </div>
              <div class="progress-section">
                <div class="progress-title">
                  <h4>Pazarlama</h4>
                  <span class="title">91%</span>
                </div>
                <div class="progress">
                  <div class="progress-bar psc02" role="progressbar" aria-valuenow="88" aria-valuemin="0"
                    aria-valuemax="100" style="max-width: 88%"></div>
                </div>
              </div>
              <div class="progress-section mb-0">
                <div class="progress-title">
                  <h4>Tasarım & Yazılım Geliştirme</h4>
                  <span class="title">95%</span>
                </div>
                <div class="progress">
                  <div class="progress-bar psc03" role="progressbar" aria-valuenow="95" aria-valuemin="0"
                    aria-valuemax="100" style="max-width: 95%"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutUs",
};
</script>